export default __webpack_public_path__ + "static/media/radio-button.c97f7993.svg";